module.exports = __webpack_public_path__ + "img/company_incoporation.34787a78.png";